// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39oXK","col":"styles_col__Fmrw7"};